import { Link } from "react-router-dom";
import type { Entry } from "@/mocks/entries";
import { formatHot, getHotEntries } from "@/hooks/useSiteData";

export default function EntrySidebar({ entry }: { entry: Entry }) {
  const hotList = getHotEntries(5);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
        <div className="flex items-center gap-3">
          <img
            src={entry.avatar}
            alt={`${entry.name} 头像`}
            title={`${entry.name} 词条`}
            className="h-14 w-14 rounded-full object-cover"
          />
          <div>
            <h2 className="font-heading text-base font-bold text-foreground-950">{entry.name}</h2>
            <p className="text-xs text-foreground-500">{entry.alias}</p>
          </div>
        </div>

        <dl className="mt-5 space-y-3 border-t border-background-200 pt-4">
          {entry.basicInfo.map((info) => (
            <div key={info.label} className="flex items-start justify-between gap-3 text-sm">
              <dt className="shrink-0 text-foreground-500">{info.label}</dt>
              <dd className="text-right text-foreground-900">{info.value}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-sm">
          <span className="text-foreground-500">当前热度</span>
          <span className="flex items-center gap-1 font-medium text-primary-700">
            <i className="ri-fire-line"></i>
            {formatHot(entry.hot)}
          </span>
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">热度榜前五</h2>
        <ol className="mt-4 space-y-3">
          {hotList.map((item, index) => (
            <li key={item.id}>
              <Link to={`/entry/${item.id}`} className="group flex items-start gap-3">
                <span
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-[11px] font-medium ${
                    index < 3 ? "bg-accent-100 text-accent-800" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <span className="block text-xs text-foreground-500">{formatHot(item.hot)} 热度</span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50/70 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-accent-800">
          <i className="ri-shield-check-line"></i> 阅读提示
        </h2>
        <p className="mt-2 text-xs leading-relaxed text-accent-900/80">
          本词条只整理公开渠道出现过的信息，不收录任何非公开个人内容。涉及匿名来源的说法已在基本信息中标注可信度，请自行判断。
        </p>
      </div>
    </aside>
  );
}